import { dispatchAndUnwrap } from 'helpers/api';
import { masterDataApi } from 'services/masterDataApi';
import { setUsePartnerLogonUrl } from 'store/appSlice';
import { setPartnerNavigation, setSiteId } from 'store/navigationSlice';

/**
 * Sets the information needed for the Partner tab drawer in Provider
 * Portal.
 *
 * Optionally, will update the drawer and make a call into Master Data
 * Service to retrieve the latest information about the partner - this is
 * needed if features of the partner have been disabled/enabled, which in
 * turn might require links in the drawer to be hidden/shown that were not
 * previously.
 *
 * @param {func} dispatch The dispatch function used to dispatch other actions
 * in this function.
 * @param {object} masterData An object representing the Authorization of the
 * logged in user. This includes permissions, roles, directReports, etc.
 * @param {object} user An object that contains the decoded values of the JWT
 * being used in the page (as well as an encoded copy of said token).
 * @param {bool} updateDrawer (Optional) Whether to update the partner drawer
 * or not. If not specified, will default to false.
 */
export const setPartnerInformation = async (
  dispatch,
  masterData,
  user,
  updateDrawer = false
) => {
  // TODO: SC-16059
  // Check if master data stuff is found,
  // If not found call resync to get new JWT and need to update partner with it
  const partner = await dispatchAndUnwrap(
    dispatch,
    masterDataApi.endpoints.getPartner,
    {
      masterEmployeeId: user?.masterEmployeeId,
    },
    updateDrawer
  );

  await dispatchAndUnwrap(dispatch, masterDataApi.endpoints.getLoginDetails);
  dispatch(setUsePartnerLogonUrl({ usePartnerLogonUrl: true }));
  dispatch(setPartnerNavigation(masterData, partner, updateDrawer));
  dispatch(setSiteId({ siteId: user?.site }));
};
